import React, { useEffect } from 'react'
import './paymentMethods.scss';
import { Button, Card, CardContent, CircularProgress, Typography } from '@material-ui/core';
import { Download } from '@mui/icons-material'
import { downloadBankSlip, getPurchaseOrder } from '../../store/paymentMethods/actions';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentStepAction } from '../../store/navigationSteps/actions';
import { withRouter } from 'react-router';
import Breadcrumbs from '../../components/breadcrumbs';
import currency from '../../helper/currency';
import moment from 'moment';
import { Stack } from '@mui/material';

const RenderCoupon = ({ text }) => (
  <Stack direction='row'>
    <svg width="25" height="15" viewBox="0 0 41 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.24 8.25L28.7 10.725L14.76 24.75L12.3 22.275L26.24 8.25ZM4.1 0H36.9C39.1755 0 41 1.83562 41 4.125V12.375C39.9126 12.375 38.8698 12.8096 38.1009 13.5832C37.332 14.3568 36.9 15.406 36.9 16.5C36.9 17.594 37.332 18.6432 38.1009 19.4168C38.8698 20.1904 39.9126 20.625 41 20.625V28.875C41 31.1644 39.1755 33 36.9 33H4.1C3.01261 33 1.96976 32.5654 1.20086 31.7918C0.431963 31.0182 0 29.969 0 28.875V20.625C2.2755 20.625 4.1 18.7894 4.1 16.5C4.1 15.406 3.66804 14.3568 2.89914 13.5832C2.13024 12.8096 1.08739 12.375 0 12.375V4.125C0 3.03098 0.431963 1.98177 1.20086 1.20818C1.96976 0.434597 3.01261 0 4.1 0ZM4.1 4.125V9.36375C5.34574 10.0864 6.38033 11.1265 7.09967 12.3792C7.81902 13.632 8.19774 15.0532 8.19774 16.5C8.19774 17.9468 7.81902 19.368 7.09967 20.6208C6.38033 21.8735 5.34574 22.9136 4.1 23.6362V28.875H36.9V23.6362C35.6543 22.9136 34.6197 21.8735 33.9003 20.6208C33.181 19.368 32.8023 17.9468 32.8023 16.5C32.8023 15.0532 33.181 13.632 33.9003 12.3792C34.6197 11.1265 35.6543 10.0864 36.9 9.36375V4.125H4.1ZM15.375 8.25C17.0765 8.25 18.45 9.63188 18.45 11.3438C18.45 13.0556 17.0765 14.4375 15.375 14.4375C13.6735 14.4375 12.3 13.0556 12.3 11.3438C12.3 9.63188 13.6735 8.25 15.375 8.25ZM25.625 18.5625C27.3265 18.5625 28.7 19.9444 28.7 21.6562C28.7 23.3681 27.3265 24.75 25.625 24.75C23.9235 24.75 22.55 23.3681 22.55 21.6562C22.55 19.9444 23.9235 18.5625 25.625 18.5625Z" fill="#672CB0" />
    </svg>

    <Typography color='primary' style={{ fontWeight: 'bold', fontSize: 12 }}>{text}</Typography>
  </Stack>
)

const PaymentMethods = ({ history }) => {
  const dispatch = useDispatch();
  const { navigationStepsReducer, paymentMethodsReducer } = useSelector(state => state);

  useEffect(() => {
    dispatch(getPurchaseOrder(history));
  }, []);

  const handleCreditCardPayment = () => {
    const nextStep = navigationStepsReducer.navigations.Groups[7];

    dispatch(setCurrentStepAction(nextStep))
    history.push(nextStep.URL);
  }

  const handlebankSlip = () => {
    dispatch(downloadBankSlip(() => {
      history.push("/conclusion");
    }));
  }

  const getDiscountText = (couponInfo) => {
    if (!couponInfo) return '';
    if (couponInfo.type === 'Percent') {
      return `${couponInfo?.value?.toFixed(0)}%`
    } else {
      return `R$${couponInfo?.value?.toFixed(0)}`
    }
  }

  if (paymentMethodsReducer.loading) {
    return (
      <div className='container'>
        <div className="col">
          <Breadcrumbs />
        </div>
        <div className='errorContainer'>
          <CircularProgress style={{ color: '#582597' }} />
        </div>
      </div>
    )
  }

  if (!paymentMethodsReducer.purchaseOrder?.id) {
    return (
      <div className='errorContainer'>
        <div className="col" />
        <p className='erroLabel'>Desculpe, não foi possível carregar os dados de pagamento no momento. Por favor, entre em contato com nosso suporte para assistência. Agradecemos sua compreensão!</p>
        <p className='erroLabel'>{paymentMethodsReducer.error}</p>
        <a href="mailto:suporte@zipcondominio.com">suporte@zipcondominio.com</a>
      </div>
    )
  }

  return (
    <section className='container'>

      <div className="col">
        <Breadcrumbs />
      </div>

      <div className='payment-methods'>
        <div className='description'>
          <div>
            <label>Descrição: </label>
            <span>{paymentMethodsReducer.purchaseOrder?.description}</span>
          </div>
          {!!paymentMethodsReducer.purchaseOrder?.purchaseOrderInfo && (
            <div>
              <label>Plano: </label>
              <span>{paymentMethodsReducer.purchaseOrder?.purchaseOrderInfo?.name.replace('Plano ', '')}</span>
            </div>
          )}
          {/* <div>
            <label>Vencimento: </label>
            <span>{moment(paymentMethodsReducer.purchaseOrder?.dateDue).format('DD/MM/YYYY')}</span>
          </div> */}
          <div>
            <label>Valor: </label>
            <span>R$ {currency(paymentMethodsReducer.purchaseOrder?.valueGross)}</span>
          </div>
          {paymentMethodsReducer.purchaseOrder?.couponInfo?.isValid && (
            <>
              <RenderCoupon text={`Cupom de ${getDiscountText(paymentMethodsReducer.purchaseOrder.couponInfo)} adicionado`} />
              <div>
                <label>Total: </label>
                <span>R$ {currency(paymentMethodsReducer.purchaseOrder?.valueTotal)}</span>
              </div>
            </>
          )}
        </div>

        <span>Formas de pagamento:</span>

        <div className='methods'>
          <Card className='card'>
            <CardContent className='card-content'>
              <div>Cartão de crédito</div>

              <span className='brand-icons'>
                <svg width="74" height="25" viewBox="0 0 74 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M38.271 7.99221C38.2288 11.4748 41.2377 13.4181 43.5042 14.5737C45.8329 15.7591 46.6151 16.5194 46.6058 17.5797C46.5885 19.2021 44.7483 19.9182 43.0264 19.946C40.0221 19.9947 38.2753 19.0975 36.8867 18.4189L35.8044 23.7169C37.1977 24.3885 39.7776 24.9743 42.4529 25C48.7328 25 52.8412 21.7569 52.8635 16.7287C52.888 10.3471 44.4263 9.99389 44.4841 7.14152C44.5041 6.27661 45.2929 5.35365 47.0215 5.11897C47.8771 5.00043 50.2391 4.9097 52.9169 6.1998L53.968 1.07388C52.5279 0.525295 50.677 0 48.3726 0C42.4618 0 38.3045 3.28724 38.271 7.99221ZM64.0672 0.441526C62.9205 0.441526 61.9542 1.14131 61.5229 2.21519L52.5524 24.6235H58.8277L60.0764 21.013H67.7447L68.4691 24.6235H74L69.1735 0.441526H64.0672ZM64.9451 6.97398L66.7561 16.0546H61.7964L64.9451 6.97398ZM30.6626 0.441828L25.7162 24.6232H31.696L36.6401 0.441223H30.6626M21.8164 0.441223L15.5923 16.9007L13.0746 2.9059C12.7792 1.34363 11.6125 0.441526 10.3169 0.441526H0.142508L0 1.14373C2.08877 1.61792 4.46197 2.38272 5.89977 3.20106C6.77967 3.70095 7.03058 4.13794 7.31964 5.32582L12.0883 24.6235H18.4075L28.0957 0.441526L21.8164 0.441223Z" fill="url(#paint0_linear_5500_2602)" />
                  <defs>
                    <linearGradient id="paint0_linear_5500_2602" x1="3402.08" y1="75.15" x2="3477.78" y2="-2492.19" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#222357" />
                      <stop offset="1" stop-color="#254AA5" />
                    </linearGradient>
                  </defs>
                </svg>

                <svg width="55" height="33" viewBox="0 0 55 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.064 3.52734H34.935V29.469H20.064V3.52734Z" fill="#FF5F00" />
                  <path d="M21.0085 16.5C21.0085 11.2292 23.5578 6.55415 27.4761 3.52908C24.5965 1.32912 20.9614 0 16.9958 0C7.6007 0 0 7.37906 0 16.5C0 25.6207 7.6007 33 16.9956 33C20.9612 33 24.5963 31.6709 27.4761 29.4707C23.5578 26.4916 21.0085 21.7708 21.0085 16.5Z" fill="#EB001B" />
                  <path d="M55 16.5C55 25.6207 47.3993 33 38.0044 33C34.0388 33 30.4037 31.6709 27.5239 29.4707C31.4895 26.4459 33.9917 21.7708 33.9917 16.5C33.9917 11.2292 31.4422 6.55415 27.5239 3.52908C30.4035 1.32912 34.0388 0 38.0044 0C47.3993 0 55 7.42499 55 16.5Z" fill="#F79E1B" />
                </svg>
              </span>
              <Button
                onClick={handleCreditCardPayment}
                fullWidth
                variant='outlined'>
                Pagar com cartão de crédito
              </Button>
            </CardContent>
          </Card>

          <Card className='card'>
            <CardContent className='card-content'>
              <div>
                <span>
                  <svg width="25" height="25" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.3177 8.9538C16.3177 8.40151 15.87 7.9538 15.3177 7.9538C14.7654 7.9538 14.3177 8.40151 14.3177 8.9538H16.3177ZM14.3177 21.6824C14.3177 22.2346 14.7654 22.6824 15.3177 22.6824C15.87 22.6824 16.3177 22.2346 16.3177 21.6824H14.3177ZM14.3177 28.0466C14.3177 28.5989 14.7654 29.0466 15.3177 29.0466C15.87 29.0466 16.3177 28.5989 16.3177 28.0466H14.3177ZM16.3177 26.4556C16.3177 25.9033 15.87 25.4556 15.3177 25.4556C14.7654 25.4556 14.3177 25.9033 14.3177 26.4556H16.3177ZM20.6819 28.0466C20.6819 28.5989 21.1296 29.0466 21.6819 29.0466C22.2341 29.0466 22.6819 28.5989 22.6819 28.0466H20.6819ZM22.6819 26.4556C22.6819 25.9033 22.2341 25.4556 21.6819 25.4556C21.1296 25.4556 20.6819 25.9033 20.6819 26.4556H22.6819ZM22.6819 8.9538C22.6819 8.40151 22.2341 7.9538 21.6819 7.9538C21.1296 7.9538 20.6819 8.40151 20.6819 8.9538H22.6819ZM20.6819 21.6824C20.6819 22.2346 21.1296 22.6824 21.6819 22.6824C22.2341 22.6824 22.6819 22.2346 22.6819 21.6824H20.6819ZM29.046 8.9538C29.046 8.40151 28.5983 7.9538 28.046 7.9538C27.4937 7.9538 27.046 8.40151 27.046 8.9538H29.046ZM27.046 28.0466C27.046 28.5989 27.4937 29.0466 28.046 29.0466C28.5983 29.0466 29.046 28.5989 29.046 28.0466H27.046ZM9.95361 8.9538C9.95361 8.40151 9.50589 7.9538 8.95361 7.9538C8.40132 7.9538 7.95361 8.40151 7.95361 8.9538H9.95361ZM7.95361 28.0466C7.95361 28.5989 8.40132 29.0466 8.95361 29.0466C9.50589 29.0466 9.95361 28.5989 9.95361 28.0466H7.95361ZM5.34224 35.1347L4.88824 36.0257H4.88825L5.34224 35.1347ZM1.86571 31.6581L2.75672 31.2041H2.75672L1.86571 31.6581ZM35.1343 31.6581L34.2433 31.2041V31.2041L35.1343 31.6581ZM31.6578 35.1347L32.1118 36.0257L31.6578 35.1347ZM31.6578 1.86531L31.2038 2.75631V2.75632L31.6578 1.86531ZM35.1343 5.34193L34.2433 5.79591V5.79591L35.1343 5.34193ZM5.34224 1.86531L5.79624 2.75631L5.34224 1.86531ZM1.86571 5.34193L2.75672 5.79591L1.86571 5.34193ZM12.1394 1.99999C12.6917 1.99803 13.1378 1.54872 13.1359 0.99644C13.1339 0.444159 12.6846 -0.00195956 12.1323 6.31809e-06L12.1394 1.99999ZM24.8677 6.31809e-06C24.3154 -0.00195956 23.8661 0.444159 23.8641 0.99644C23.8622 1.54872 24.3083 1.99803 24.8606 1.99999L24.8677 6.31809e-06ZM2 24.732C1.99837 24.1797 1.54934 23.7333 0.997062 23.7349C0.444779 23.7366 -0.0016185 24.1856 4.29153e-06 24.7379L2 24.732ZM37 24.7379C37.0016 24.1856 36.5552 23.7366 36.0029 23.7349C35.4507 23.7333 35.0016 24.1797 35 24.732L37 24.7379ZM34.9996 12.1393C35.0016 12.6916 35.4509 13.1377 36.0031 13.1357C36.5554 13.1337 37.0015 12.6844 36.9996 12.1322L34.9996 12.1393ZM12.1323 37C12.6846 37.002 13.1339 36.5558 13.1359 36.0036C13.1378 35.4513 12.6917 35.002 12.1394 35L12.1323 37ZM24.8608 35C24.3085 35.002 23.8624 35.4513 23.8643 36.0036C23.8663 36.5558 24.3156 37.002 24.8679 37L24.8608 35ZM0.000425756 12.1322C-0.00153995 12.6844 0.444579 13.1337 0.99686 13.1357C1.54914 13.1377 1.99845 12.6916 2.00041 12.1393L0.000425756 12.1322ZM14.3177 8.9538V21.6824H16.3177V8.9538H14.3177ZM16.3177 28.0466V26.4556H14.3177V28.0466H16.3177ZM22.6819 28.0466V26.4556H20.6819V28.0466H22.6819ZM20.6819 8.9538V21.6824H22.6819V8.9538H20.6819ZM27.046 8.9538V28.0466H29.046V8.9538H27.046ZM7.95361 8.9538V28.0466H9.95361V8.9538H7.95361ZM5.79624 34.2437C4.48755 33.5769 3.42354 32.5128 2.75672 31.2041L0.974701 32.1121C1.83326 33.7971 3.20322 35.1671 4.88824 36.0257L5.79624 34.2437ZM34.2433 31.2041C33.5765 32.5128 32.5125 33.5769 31.2038 34.2437L32.1118 36.0257C33.7968 35.1671 35.1667 33.7971 36.0253 32.1121L34.2433 31.2041ZM31.2038 2.75632C32.5125 3.42314 33.5765 4.48717 34.2433 5.79591L36.0253 4.88795C35.1667 3.20289 33.7968 1.83289 32.1118 0.97431L31.2038 2.75632ZM4.88824 0.974311C3.20322 1.83289 1.83326 3.20289 0.974701 4.88795L2.75672 5.79591C3.42354 4.48717 4.48755 3.42314 5.79624 2.75631L4.88824 0.974311ZM12.1323 6.31809e-06C8.77504 0.0119568 6.62713 0.0882822 4.88824 0.974311L5.79624 2.75631C7.02915 2.1281 8.65504 2.0124 12.1394 1.99999L12.1323 6.31809e-06ZM24.8606 1.99999C28.345 2.0124 29.9709 2.1281 31.2038 2.75631L32.1118 0.974311C30.3729 0.0882822 28.225 0.0119568 24.8677 6.31809e-06L24.8606 1.99999ZM4.29153e-06 24.7379C0.0100964 28.1724 0.078402 30.3529 0.974701 32.1121L2.75672 31.2041C2.11984 29.9541 2.01049 28.3032 2 24.732L4.29153e-06 24.7379ZM35 24.732C34.9895 28.3032 34.8802 29.9541 34.2433 31.2041L36.0253 32.1121C36.9216 30.3529 36.9899 28.1724 37 24.7379L35 24.732ZM36.9996 12.1322C36.9876 8.77481 36.9113 6.62686 36.0253 4.88795L34.2433 5.79591C34.8715 7.02886 34.9872 8.65481 34.9996 12.1393L36.9996 12.1322ZM12.1394 35C8.65504 34.9876 7.02915 34.8719 5.79624 34.2437L4.88825 36.0257C6.62713 36.9117 8.77504 36.988 12.1323 37L12.1394 35ZM24.8679 37C28.225 36.988 30.3729 36.9117 32.1118 36.0257L31.2038 34.2437C29.9709 34.8719 28.345 34.9876 24.8608 35L24.8679 37ZM2.00041 12.1393C2.01282 8.65481 2.12852 7.02886 2.75672 5.79591L0.974701 4.88795C0.0887005 6.62686 0.0123759 8.77481 0.000425756 12.1322L2.00041 12.1393Z" fill="#582597" />
                  </svg>
                </span>
                <span>
                  Boleto
                </span>
              </div>
              <Button
                disabled={paymentMethodsReducer.bankSlipLoading}
                onClick={handlebankSlip}
                fullWidth
                variant='outlined'>
                {
                  paymentMethodsReducer.bankSlipLoading ? (
                    <CircularProgress size={16} style={{ marginRight: 10 }} />
                  ) : (
                    <Download sx={{ marginRight: 1 }} />
                  )
                }
                <span>Baixe o boleto</span>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}

export default withRouter(PaymentMethods);
